import React, { useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { Controller, FormProvider, useForm } from "react-hook-form";
import Mutations from "../../../api/mutations";
import { mobUser } from "../../../mobx/MobUser";
import i18n from "../../../i18n";
import FieldErrorText from "../../../components/FieldErrortext";
import AppInput from "../../../components/AppInput";
import AppButton from "../../../components/AppButton";
import { useTheme } from "react-native-paper";
import { Text } from "../../../utils/fontsLoader";
import { useNavigation } from "@react-navigation/native";
import { mobAlert } from "../../../mobx/MobAlert";
import { emailRegex } from "../../../utils/formUtils";
import PropTypes from "prop-types";

const InvoiceForm = ({ checkInInfos, alreadyAsked }) => {
  const navigation = useNavigation();
  const theme = useTheme();
  const mutations = new Mutations();

  const formMethods = useForm({
    defaultValues: {
      email: checkInInfos?.email || mobUser.Email || "",
      companyName: "",
      companyAddress: "",
    },
  });

  const {
    control,
    reset,
    getValues,
    handleSubmit,
    formState: { errors },
  } = formMethods;

  useEffect(() => {
    // Mise à jour des valeurs par défaut du formulaire avec les nouvelles données de checkInInfos
    reset({
      ...getValues(),
      email: checkInInfos?.email || mobUser.Email || "",
    });
  }, [checkInInfos, reset, getValues]);

  const onSubmit = (data) => {
    mobAlert.setAlert(
      i18n.t("alert.INVOICE_VALIDATION_TITLE"),
      i18n.t("alert.INVOICE_VALIDATION_SUBTITLE"),
      i18n.t("pages.invoice.submit"),
      () => {
        const InvoiceData = {
          ...data,
          bookingId: mobUser.OiqiaBookingId,
        };
        mutations.askInvoice(InvoiceData).then(() => {
          mobAlert.setSuccess(
            i18n.t("pages.invoice.successTitle"),
            i18n.t("pages.invoice.successMessage"),
            () => {
              mobAlert.closeSuccess();
              navigation.goBack();
            }
          );
        });
      },
      i18n.t("generic.cancel"),
      mobAlert.closeAlert
    );
  };

  return (
    <FormProvider {...formMethods}>
      <Controller
        control={control}
        rules={{
          required: i18n.t("errors.missingField"),
          pattern: {
            value: emailRegex,
            message: i18n.t("errors.emailFormatError")
          }
        }}
        render={({ field: { onChange, value } }) => (
          <View style={styles.field}>
            <Text style={styles.label}>
              {i18n.t("pages.checkIn.email")}
            </Text>
            <AppInput
              value={value}
              onChangeText={onChange}
              additionalStyle={styles.inputText}
              autoCapitalize="none"
              keyboardType="email-address"
            />
            {errors.email && <FieldErrorText errorMessage={errors.email.message} />}
          </View>
        )}
        name="email"
      />
      <Controller
        control={control}
        rules={{
          required: false,
        }}
        render={({ field: { onChange, value } }) => (
          <View style={styles.field}>
            <Text style={styles.label}>
              {i18n.t("pages.invoice.companyName")}
            </Text>
            <AppInput
              value={value}
              onChangeText={onChange}
              additionalStyle={styles.inputText}
            />
          </View>
        )}
        name="companyName"
      />
      <Controller
        control={control}
        rules={{
          required: false,
        }}
        render={({ field: { onChange, value } }) => (
          <View style={styles.field}>
            <Text style={styles.label}>
              {i18n.t("pages.invoice.companyAddress")}
            </Text>
            <AppInput
              value={value}
              onChangeText={onChange}
              additionalStyle={styles.inputText}
            />
          </View>
        )}
        name="companyAddress"
      />
      {!alreadyAsked ?
        <AppButton extraStyle={styles.submitButton} color={theme.colors.primary} onPress={handleSubmit(onSubmit)}>
          {i18n.t("pages.invoice.submit")}
        </AppButton>
        :
        <AppButton extraStyle={styles.submitButton} color={"red"} disabled={true} onPress={() => null}>
          {i18n.t("pages.invoice.alreadyAsked")}
        </AppButton>
      }
    </FormProvider>
  );
};

InvoiceForm.propTypes = {
  checkInInfos: PropTypes.shape({
    email: PropTypes.string,
  }),
};

const styles = StyleSheet.create({
  field: {
    gap: 10
  },
  label: {
    fontSize: 20,
    textAlign: "center"
  },
  inputText: {
    fontSize: 20,
    fontFamily: "NotoSans-Light",
  },
  submitButton: {
    marginTop: 20
  },
});

export default InvoiceForm;